export const SCROLLING_TIME_IN_MS = 600;
export const GAME_TABLE_ID = 'games-table';
